var _regeneratorRuntime = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var BufferList = require('bl/BufferList');

var TypeDefault = {
  string: function string() {
    return '';
  },
  buffer: function buffer() {
    return BufferList();
  }
};

module.exports = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source, options) {
    var res, type, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = options || {};

            if (!(options.type && !TypeDefault[options.type])) {
              _context.next = 3;
              break;
            }

            throw new Error("invalid type \"".concat(options.type, "\""));

          case 3:
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 5;
            _iterator = _asyncIterator(source);

          case 7:
            _context.next = 9;
            return _iterator.next();

          case 9:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 13;
            return _step.value;

          case 13:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 21;
              break;
            }

            chunk = _value;

            if (!res) {
              type = options.type || typeof chunk === 'string' ? 'string' : 'buffer';
              res = TypeDefault[type]();
            }

            if (type === 'string') {
              res += chunk;
            } else {
              res.append(chunk);
            }

          case 18:
            _iteratorNormalCompletion = true;
            _context.next = 7;
            break;

          case 21:
            _context.next = 27;
            break;

          case 23:
            _context.prev = 23;
            _context.t0 = _context["catch"](5);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 27:
            _context.prev = 27;
            _context.prev = 28;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 32;
              break;
            }

            _context.next = 32;
            return _iterator.return();

          case 32:
            _context.prev = 32;

            if (!_didIteratorError) {
              _context.next = 35;
              break;
            }

            throw _iteratorError;

          case 35:
            return _context.finish(32);

          case 36:
            return _context.finish(27);

          case 37:
            return _context.abrupt("return", res || TypeDefault[options.type || 'buffer']());

          case 38:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 23, 27, 37], [28,, 32, 36]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();